import { Button, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material"
import {useDispatch, useSelector} from "react-redux"
import {useEffect, useState} from "react"
import {isEmail} from "validator"
import {
	clearManageWorkspaceView,
	setUpdatedInviteEmailValue,
	modifyAuthorInvite,
	MANAGE_WORKSPACE_VIEW,
	selectIsModifyingAuthor, selectTargetUser,
	setManageWorkspaceView,
	setTargetUser,
} from "../../reducers/manageWorkspaceSlice"
import {ManageModalContainer} from "./shared_components/ManageModalContainer"

export function InviteAuthor() {
	const [validEmail, setIsValidEmail] = useState(false)
	const [emailInput, setEmailInput] = useState("")

	const dispatch = useDispatch()
	const isModifyingAuthor = useSelector(selectIsModifyingAuthor)
	const authorInvite = useSelector(selectTargetUser)

	useEffect(() => {
		if(isModifyingAuthor && authorInvite) {
			setEmailInput(authorInvite.user.email)
		}
	}, [])

	const handleChange = (e) => {
		const email = e.target.value
		setEmailInput(email)
		if (!isModifyingAuthor && email.length >= 3) {
			setIsValidEmail(isEmail(email) === false)
		} else if(isModifyingAuthor && email.length >= 3) {
			setIsValidEmail(isEmail(email) === false)
		} else {
			setIsValidEmail(false)
		}
	}

	const handleClick = async () => {
		if(isModifyingAuthor) {
			await dispatch(setUpdatedInviteEmailValue(emailInput))
			dispatch(modifyAuthorInvite())
				.then(() => {
					dispatch(setManageWorkspaceView(MANAGE_WORKSPACE_VIEW.MANAGE_INVITES))
				})
		} else {
			/*
				We are creating a new Author Invite. This will require data shaped like an AuthorInviteConstructor
				However, our Redux slice is expecting data shaped like a WorkspaceMemberDTO. So here, we are making
				a fake workspace member using the values that will be applied to the invited author's user object
			 */
			const fakeWorkspaceMemberDTO = {
				user: {
					firstName: "Invited",
					lastName: "Author",
					email: emailInput,
					id: -1 // this is used as a flag for an invited user or author in some legacy code
				},
				workspacePermissions: {
					read: true,
					write: true,
					admin: false,
				},
				selectedNoteIds: {}
			}
			dispatch(setTargetUser(fakeWorkspaceMemberDTO))
			dispatch(setManageWorkspaceView(MANAGE_WORKSPACE_VIEW.NOTE_PERMISSIONS))
		}
	}

	return (
		<ManageModalContainer>
			<DialogTitle>
				Invite new Author to workspace
			</DialogTitle>
			<DialogContent sx={{padding: "5rem"}}>
				<TextField
					fullWidth
					label="Enter an e-mail"
					variant="standard"
					value={emailInput}
					onChange={handleChange}
					error={validEmail}
				/>
			</DialogContent>
			<DialogActions sx={{padding: "0 5rem"}}>
				<Button
					variant={"outlined"}
					color={"primary"}
					onClick={handleClick}
					fullWidth
					disabled={emailInput.length < 3 || validEmail}
				>
					Next
				</Button>
				<Button
					variant={"outlined"}
					color={"error"}
					onClick={() => dispatch(clearManageWorkspaceView())}
				>
					Cancel
				</Button>
			</DialogActions>
		</ManageModalContainer>
	)
}